import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';
import { useEffect } from '@wordpress/element';
import { useSelect, dispatch } from '@wordpress/data';
import SidePanel from './sidePanel';
import { RangeControl } from '@wordpress/components';
import { t } from "drupal";
import { store as blockEditorStore } from "@wordpress/block-editor";
import { useDispatch } from '@wordpress/data';
import { store as noticesStore } from '@wordpress/notices';
import CustomRepater from "./customRepeater.js";



const AVAILABLE_BLOCKS = ['deohs-gutenberg-blocks/deohs-profile-card',];
const TEMPLATE = [["deohs-gutenberg-blocks/deohs-profile-card", {}]];


const Edit = ({ attributes, setAttributes, clientId }) => {
    const blockProps = useBlockProps();
    const { numCols } = attributes;

    const innerBlocks = useSelect(
        (select) => select('core/block-editor').getBlocks(clientId),
        [clientId]
    );

    const BLOCK_LABELS = {
        'deohs-gutenberg-blocks/deohs-profile-card': 'Profile Card',
    };

    const invalidBlocks = useSelect((select) => {
        const { getBlocks } = select(blockEditorStore);
        const innerBlocks = getBlocks(clientId);

        return innerBlocks
          .filter((block) => {
            const { name, attributes } = block;

            switch (name) {
              case "deohs-gutenberg-blocks/deohs-profile-card":
                return (
                  attributes.titleError ||
                  attributes.profileNameError ||
                  attributes.linkTextError ||
                  attributes.linkUrlError
                );
              default:
                return false;
            }
          })
          .map((block) => BLOCK_LABELS[block.name] || block.name); // Map to readable labels
      }, [clientId]);



    // Apply Bootstrap row classes based on numCols
    useEffect(() => {
        const gridContainer = document.querySelector(`[data-block="${clientId}"] .row`);
        if (gridContainer) {
            gridContainer.className = `row row-cols-1 row-cols-sm-2 row-cols-md-${numCols} g-3`;
        }
    }, [numCols, clientId]);

    const updateNumCols = (value) => {
        setAttributes({ numCols: value });
    };


    return (
        <>
            {invalidBlocks.length > 0 && (
                <div className="parent-block-container-error">
                    <p>The following blocks have errors and must be fixed before saving:</p>
                    <ul>
                        {invalidBlocks.map((blockName, index) => (
                            <li key={index}>{blockName}</li>
                        ))}
                    </ul>
                </div>
            )}

            {/* Side Panel */}
            <SidePanel
                numCols={numCols}
                updateNumCols={updateNumCols}

            />

            {/* Block Layout */}
            <div {...blockProps}>
                <div className={`row row-cols-1 row-cols-md-${numCols} g-3`}>
                    <InnerBlocks
                        allowedBlocks={AVAILABLE_BLOCKS}
                        template={TEMPLATE}
                        templateLock={false}
                        renderAppender={false}
                    />
                </div>
                <CustomRepater />
            </div>
        </>
    );
};

export default Edit;
